import { truncate } from "../../utils/truncate";
import "./ProfileProjects.css";
import thumbnails from "../../utils/thumbnails.json";
import { useState } from "react";
import ViewProjects from "../ViewProjects";
import { useHistory } from "react-router";

const ProfileProjects = ({ userProfile, setTab }) => {
  const [openProjects, setOpenProjects] = useState(false);
  const history = useHistory();
  const userBusiness = userProfile && userProfile.identity.job === "Business";
  const userGenius = userProfile && userProfile.identity.job === "Genius";
  const userTeacher = userProfile && userProfile.identity.job === "Teacher";
  const videosTeacher =
    userProfile &&
    thumbnails.filter((thumb) => thumb.channel.id === userProfile.id);

  const [profileProjects] = useState(
    userGenius
      ? userProfile?.projects
      : userBusiness
      ? userProfile?.products
      : userTeacher
      ? videosTeacher
      : [
          {
            id: 1,
            img: "/images/pictures/projects/profile/interior-modern.jpg",
            description:
              "As Uber works through a huge amount of internal management turmoil.",
            projects_ranking:
              "https://gist.githubusercontent.com/geniusparkle-team/a78775c79f9d3291e3360c4cb3bbb71c/raw/e1815c9584fb2a8c49638c6d34a373d18b2ffe9a/2.svg",
            title: "Modern",
          },
          {
            id: 2,
            projects_ranking:
              "https://gist.githubusercontent.com/geniusparkle-team/a78775c79f9d3291e3360c4cb3bbb71c/raw/e1815c9584fb2a8c49638c6d34a373d18b2ffe9a/4.svg",
            img: "/images/pictures/projects/profile/interior-scandinavian.jpg",
            description:
              "Music is something that every person has his or her own specific opinion about.",
            title: "Scandinavian",
          },
          {
            id: 3,
            projects_ranking:
              "https://gist.githubusercontent.com/geniusparkle-team/a78775c79f9d3291e3360c4cb3bbb71c/raw/e1815c9584fb2a8c49638c6d34a373d18b2ffe9a/3.svg",
            img: "/images/pictures/projects/profile/interior-minimalist.jpg",
            description:
              "Different people have different taste, and various types of music.",
            title: "Minimalist",
          },
        ]
  );

  // https://gist.githubusercontent.com/geniusparkle-team/a78775c79f9d3291e3360c4cb3bbb71c/raw/e1815c9584fb2a8c49638c6d34a373d18b2ffe9a/1.svg

  const handleOpen = () => {
    if (userTeacher) {
      history.push(`/videos/teacher/${userProfile.id}`);
    }
    setOpenProjects(true);
  };

  return (
    <div className="profileProjects">
      <h3>
        {userBusiness ? "Products" : userTeacher ? "Playlist" : "Projects"}
      </h3>
      <ul className="profileProjects__items">
        {profileProjects.map(
          (project, i) =>
            i < 3 && (
              <li className="flex-column" key={project.id}>
                <div className="profileProjects__ranking">
                  <img src={project.projects_ranking} alt={project.title} />
                </div>
                <div>
                  <div
                    className={`profileProjects__imgContainer ${
                      project.premium && "premium-video"
                    }`}
                  >
                    <img src={project.img} alt={project.title} />
                  </div>
                  <h4 className="flex-row">{truncate(project.title, 20)}</h4>
                  <p>{truncate(project.description, 50)}</p>
                </div>
                <div onClick={handleOpen}>
                  <button className="btn">
                    {userBusiness
                      ? "View Product"
                      : userTeacher
                      ? "View Playlist"
                      : "View Project"}
                  </button>
                </div>
              </li>
            )
        )}
        {!userProfile && (
          <li
            className="profileProjects__create"
            onClick={() => setTab("overview")}
          >
            {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/azq0S0DKS50" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12H19"
                stroke="#757679"
                stroke-width="5"
                stroke-linecap="round"
              />
              <path
                d="M12 19V5"
                stroke="#757679"
                stroke-width="5"
                stroke-linecap="round"
              />
            </svg>
            New{" "}
            {userBusiness ? "Product" : userTeacher ? "Playlist" : "Project"}
          </li>
        )}
      </ul>
      {openProjects && (
        <ViewProjects
          setOpenProjects={setOpenProjects}
          projects={
            userBusiness
              ? userProfile.products
              : userTeacher
              ? videosTeacher
              : profileProjects
          }
        />
      )}
    </div>
  );
};

export default ProfileProjects;
